import React, { Suspense } from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import Loadable from "@loadable/component"

const HeaderDefault = Loadable(() =>
  import("../headers/HeaderDefault/HeaderDefault")
)
const HeaderRadian = Loadable(() => import("../headers/HeaderRadian"))

const Headers = ({
  header,
  site,
  isHomepage,
  isTransparentNav,
  bgOpacityNav,
  pageSpecificNavTheme,
  firstSectionStyling,
  pageId,
}) => {
  const isSSR = typeof window === "undefined"
  if (site && site?.pages?.[0]?.hideHeader === "yes") {
    return null
  }

  header = header ?? site.header[0]
  const props = { siteTitle: site.title }
  let RenderedHeader

  switch (header?.__typename || header?.__component) {
    case "STRAPI__COMPONENT_HEADERS_DEFAULT":
    case "headers.default":
      RenderedHeader = (
        <HeaderDefault
          {...header}
          {...props}
          site={site}
          isHomepage={isHomepage}
          pageSpecificNavTheme={pageSpecificNavTheme}
          isTransparentNav={isTransparentNav}
          bgOpacityNav={bgOpacityNav}
          firstSectionStyling={firstSectionStyling}
        />
      )
      break
    case "STRAPI__COMPONENT_HEADERS_RADIAN":
    case "headers.radian":
      RenderedHeader = (
        <HeaderRadian {...header} {...props} isHomepage={isHomepage} />
      )
      break
    default:
      return null
  }
  if (isSSR) return RenderedHeader
  else return <Suspense fallback={<></>}>{RenderedHeader}</Suspense>
}

export default Headers

Headers.propTypes = {
  site: PropTypes.object.isRequired,
}

export const query = graphql`
  fragment Headers on SiteHeaderDynamicZone {
    __typename
    ... on STRAPI__COMPONENT_HEADERS_DEFAULT {
      ...HeaderDefault
    }
    ... on STRAPI__COMPONENT_HEADERS_RADIAN {
      ...HeaderRadian
    }
  }
`
